import { addRolesToOrganisationUser, createOrganisationUser } from '@infuse/api/iam/organisation';
import { useGenericCreateUser } from '@infuse/iam/user/mutations';

export const useCreateOrganisationUser = () =>
  useGenericCreateUser({
    apiFn: createOrganisationUser,
    roleApiFn: addRolesToOrganisationUser
  });
